import { render, staticRenderFns } from "./NotesCaption.vue?vue&type=template&id=75ad4a4a&scoped=true&"
import script from "./NotesCaption.vue?vue&type=script&lang=js&"
export * from "./NotesCaption.vue?vue&type=script&lang=js&"
import style0 from "./NotesCaption.vue?vue&type=style&index=0&id=75ad4a4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ad4a4a",
  null
  
)

export default component.exports